module.exports = __webpack_public_path__ + "static/media/pic5.7b00112a.jpg";